import './style.css';
import './corridor.css';
import type { Manifest } from './contracts.ts';
import type { CorridorConfig } from './corridor-contracts.ts';
import { validCorridor } from './corridor-contracts.ts';

let starting=false;
const start=document.getElementById('start') as HTMLButtonElement;
start.addEventListener('click',()=>{void begin();});
async function begin():Promise<void> {
  if(starting)return;starting=true;start.disabled=true;
  const panel=document.getElementById('start-panel')!,loading=document.getElementById('loading')!;
  panel.hidden=true;loading.hidden=false;
  let viewer:import('./viewer.ts').Viewer|undefined;
  try {
    const baseUrl=new URL('/explore-3d/model/',document.baseURI),corridorUrl=new URL('./model/',document.baseURI);
    const [baselineResponse,corridorResponse,module]=await Promise.all([fetch(new URL('manifest.json',baseUrl)),fetch(new URL('corridor.json',corridorUrl)),import('./viewer.ts')]);
    if(!baselineResponse.ok || !corridorResponse.ok)throw new Error('MODEL_UNAVAILABLE');
    const [baselineBytes,config]=await Promise.all([baselineResponse.arrayBuffer(),corridorResponse.json() as Promise<CorridorConfig>]);
    const manifest=JSON.parse(new TextDecoder().decode(baselineBytes)) as Manifest;
    const hash=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',baselineBytes)),byte=>byte.toString(16).padStart(2,'0')).join('');
    if(config.baselineManifestSha256.toLowerCase()!==hash)throw new Error('Corridor baseline differs');
    validCorridor(config,manifest);
    viewer=new module.Viewer(manifest,baseUrl,{config,modelUrl:corridorUrl});await viewer.start();
  } catch(error) {
    viewer?.dispose();
    loading.hidden=true;panel.hidden=false;
    document.getElementById('start-title')!.textContent=(error as Error).message==='WEBGL_UNAVAILABLE'?'3D is unavailable in this browser':'The walking route could not load';
    document.getElementById('start-description')!.textContent='Try again with hardware acceleration enabled and the complete route files available, or explore the existing Austin city model.';
    start.textContent='Try again';start.disabled=false;starting=false;
  }
}
